module.exports = __webpack_public_path__ + "audio-3b864ebdeba5.m4a";